<script setup>
import { computed, onMounted, ref } from "vue";
//import Conf from '@/Components/MainGlobal.vue';
import SeoMeta from '@/Components/SeoMeta.vue';
import CardBoxModal from "@/Components/CardBoxModal.vue";
import BreezeInput from '@/Components/Input.vue';
import BreezeLabel from '@/Components/Label.vue';
import BreezeCheckbox from '@/Components/Checkbox.vue';
import { Head, Link, useForm, usePage } from '@inertiajs/inertia-vue3';
//import BreezeApplicationLogo from '@/Components/ApplicationLogo.vue';
import BreezeApplicationLogoFull from '@/Components/ApplicationLogoFull.vue';
import BreezeDropdown from '@/Components/Dropdown.vue';
import BreezeDropdownLink from '@/Components/DropdownLink.vue';
import BaseButton from "@/Components/BaseButton.vue";
import Footer from '@/Components/Footer.vue';
import { Inertia } from '@inertiajs/inertia';
import BreezeGuestLayout from '@/Layouts/Guest.vue';
import { Splide, SplideSlide, SplideTrack } from '@splidejs/vue-splide';
import BaseIcon from "@/Components/BaseIcon.vue";
import helpers from '../Common/helpers';

import {
    mdiMagnify,
    mdiChevronDown,
    mdiAccountOutline,
    mdiCartOutline,
    mdiHeartOutline,
    mdiMenu,
    mdiCloseThick,
    mdiHeadset,
    mdiFacebook,
    mdiInstagram,
    mdiTwitter,
    mdiWhatsapp,
    mdiYoutube,
    mdiTruckFastOutline,
    mdiReload,
    mdiShieldLockOutline,
    mdiTrophyOutline,
    mdiArrowRight,
    mdiShoppingOutline,
    mdiStar,
    mdiArrowExpandAll,
    mdiRepeat,
    mdiAirplane,
    mdiChevronRight,
    mdiArchivePlus,
    mdiCableData,
    mdiPercent,
    mdiMoped

} from "@mdi/js";

const props = defineProps({
    canLogin: Boolean,
    canRegister: Boolean,
    laravelVersion: String,
    phpVersion: String,
    appVersion: String,
    contentWelcome: String,
    stocklabel: Number,
    accessParents: Boolean,
    slides: Object,
    promos: Object,
    categoryChild: Object,
    categoryParent: Object,
    lastproducts: Object,
    categories: Object,
    lastbrands: Object,
    lastservices: Object,
    certificates: Object
    //connstantes: Array
})

onMounted(() => {
    //getProductos()
});

// LRR
//const confGlobal = props.connstantes
/*const confGlobal = ref([])
onMounted(() => {
  let url = '/constante/global';
  axios.get(url).then(function (response) {
      var respuesta = response.data;
      confGlobal.value = respuesta.constantes;
      //console.log(me.constante);
    }).catch(function (error) {
        console.log(error);
  });
});
*/
//console.log( props.connstantes )

const qtyCart = ref(0)
const getCart = () => {
    let cart = []
    //let cartStorage = localStorage.getItem('cart')
    let cartStorage = sessionStorage.getItem('cart')
    if (cartStorage && cartStorage.length > 0) {
        cart = JSON.parse(cartStorage)
    }
    return cart
}

const addCart = (prodid = 0, cant = 1, ref = '', label = '', price = '') => {
    let cart = getCart()
    //let newObj = {'id': prodid, 'cant': cant}
    let newObj = { 'id': prodid, 'cant': cant, 'ref': ref, 'label': label, 'price': price }
    if (cart && cart.length > 0) {
        let obj = cart.find(o => o.id === prodid)
        if (obj !== undefined && obj !== null) {
            obj.cant += cant
        } else {
            cart.push(newObj)
        }
        sessionStorage.setItem('cart', JSON.stringify(cart))
        qtyCart.value = cart.length
        console.log('Upd Cart')
    } else {
        let newCart = [newObj]
        //localStorage.setItem('cart', JSON.stringify(newCart))
        sessionStorage.setItem('cart', JSON.stringify(newCart))
        qtyCart.value = newCart.length
        console.log('New Cart')
    }
    //emit('reload')

}

const form = useForm({
    email: '',
    nombre: '',
    phone: '',
    comment: '',
    recibirinfo: false
});
const isModalActive = ref(false);

//const stocklabel = ref(false) <-- Ahora está como propiedad


// Información de Slide, limite x 4

const slidePrincipal = ref(null)
slidePrincipal.value = [
    { 'id': '01', 'label': 'Vr Box 3D Glass', 'referencia_producto': 'Explora nuestra colección tecnológica', 'ruta_imagen': '/img/slide/slide-1.png' },
    { 'id': '02', 'label': 'Vr Box 3D Glass', 'referencia_producto': 'Explora nuestra colección tecnológica', 'ruta_imagen': '/img/slide/slide-2.png' },
    { 'id': '03', 'label': 'Vr Box 3D Glass', 'referencia_producto': 'Explora nuestra colección tecnológica', 'ruta_imagen': '/img/slide/slide-3.png' },
]

//produtos nuevos ORDER BY created_at LIMIT 8
const productosNuevos = ref(null)
/* const getProductos = (filter = []) => {
    //let url = '/caficiation/aula'+'?id_classroom='+props.classroom.id+'&id_course='+props.course.id+'&ref_ciclo='+props.refCicloActual;
    let url = 'ecommerce/product/list';
    //if (filter.length > 0) {
        //url += '?'+filter[0]['atributo']+'='+filter[0]['search']
    //}
    axios.get(url).then((response) => {
        let respuesta = response.data;
        productosNuevos.value = respuesta.datalist// El return directo del array trae otros datos que generan error para el chart
        console.log(productosNuevos.value);
    }).catch((error) => {
        console.log(error);
    });
} */
productosNuevos.value = [
    { 'id': '28', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'stock': '4', 'ruta_imagen': '/img/productos/01.jpg', 'stock_type': 0 },
    { 'id': '27', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 0, 'rating': 1, 'stock': '0', 'ruta_imagen': '/img/productos/02.jpg', 'stock_type': 2 },
    { 'id': '26', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 0, 'stock': '2', 'ruta_imagen': '/img/productos/03.jpg', 'stock_type': 3 },
    { 'id': '25', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'stock': '4', 'ruta_imagen': '/img/productos/04.jpg', 'stock_type': 2 },
    { 'id': '24', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'stock': '1', 'ruta_imagen': '/img/productos/05.jpg', 'stock_type': 3 },
    { 'id': '23', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'stock': '4', 'ruta_imagen': '/img/productos/06.jpg', 'stock_type': 0 },
    { 'id': '22', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'stock': '4', 'ruta_imagen': '/img/productos/07.jpg', 'stock_type': 0 },
    { 'id': '21', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'stock': '4', 'ruta_imagen': '/img/productos/08.jpg', 'stock_type': 0 }
]

const getDataAsistencia = () => {
    //let url = '/caficiation/aula'+'?id_classroom='+props.classroom.id+'&id_course='+props.course.id+'&ref_ciclo='+props.refCicloActual;
    let url = '/asistenciacolaborador/getfordashboard';
    axios.get(url).then(function (response) {
        let respuesta = response.data;
        arrayAsistencia.value = respuesta.datalist// El return directo del array trae otros datos que generan error para el chart
        console.log(arrayAsistencia.value);
    }).catch(function (error) {
        console.log(error);
    });
}

const productosDestacados = ref(null)
productosDestacados.value = [
    { 'id': '31', 'label': 'Monitor Curvo Samsung 49″ WQLED LS49A950', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'ruta_imagen': '/img/productos/20.jpg' },
    { 'id': '32', 'label': 'Tablet Samsung Galaxy Tab S7 Fe 64gb', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'ruta_imagen': '/img/productos/21.jpg' },
    { 'id': '33', 'label': 'Asus ROG Strix RX5700 XT O8G 8GB', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'ruta_imagen': '/img/productos/22.jpg' },
    { 'id': '34', 'label': 'Impresora HP LaserJet 107W', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'ruta_imagen': '/img/productos/23.jpg' },
    { 'id': '35', 'label': 'Impresora Multifuncional Epson EcoTank L3110', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'ruta_imagen': '/img/productos/24.jpg' },
    { 'id': '36', 'label': 'Mochila Lenovo Thinkpad Professional G2', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'ruta_imagen': '/img/productos/25.jpg' }
]

const categorias = ref(null)
categorias.value = [
    { 'id': '201', 'label': 'Laptops', 'ruta_imagen': '/img/categorias/01.jpg' },
    { 'id': '202', 'label': 'Procesadores', 'ruta_imagen': '/img/categorias/02.jpg' },
    { 'id': '203', 'label': 'Placas', 'ruta_imagen': '/img/categorias/03.jpg' },
    { 'id': '204', 'label': 'Case', 'ruta_imagen': '/img/categorias/04.jpg' },
    { 'id': '205', 'label': 'Memorias Ram', 'ruta_imagen': '/img/categorias/05.jpg' },
    { 'id': '206', 'label': 'Monitores', 'ruta_imagen': '/img/categorias/06.jpg' },
    { 'id': '207', 'label': 'Tarjeta de Video', 'ruta_imagen': '/img/categorias/07.jpg' },
    { 'id': '208', 'label': 'Almacenamiento', 'ruta_imagen': '/img/categorias/08.jpg' },
    { 'id': '209', 'label': 'Impresora', 'ruta_imagen': '/img/categorias/09.jpg' }
]

const marcas = ref(null)
marcas.value = [
    { 'id': '102', 'ruta_imagen': '/img/marcas/logos/acer.png' },
    { 'id': '101', 'ruta_imagen': '/img/marcas/logos/amd.png' },
    { 'id': '103', 'ruta_imagen': '/img/marcas/logos/apple.png' },
    { 'id': '104', 'ruta_imagen': '/img/marcas/logos/asus.png' },
    { 'id': '105', 'ruta_imagen': '/img/marcas/logos/cougar.png' },
    { 'id': '106', 'ruta_imagen': '/img/marcas/logos/gigabyte.png' },
    { 'id': '107', 'ruta_imagen': '/img/marcas/logos/hp.png' },
    { 'id': '108', 'ruta_imagen': '/img/marcas/logos/intel.png' },
    { 'id': '109', 'ruta_imagen': '/img/marcas/logos/lenovo.png' },
    { 'id': '110', 'ruta_imagen': '/img/marcas/logos/lg.png' },
    { 'id': '111', 'ruta_imagen': '/img/marcas/logos/nvidia.png' },
    { 'id': '112', 'ruta_imagen': '/img/marcas/logos/samsung.png' }
]

const promociones = ref(null)
promociones.value = [
    { 'id': '250', 'ruta_imagen': '/img/promociones/01.png' },
    { 'id': '251', 'ruta_imagen': '/img/promociones/02.png' },
]

const certificados = ref(null)
certificados.value = [
    { 'id': '01', 'title': 'Certificados que nos respaldan', 'subTitle': 'lorem Ipsum is simply dummy text of the printing and typesetting industry.' }
]

const certificadosLogos = ref(null)
certificadosLogos.value = [
    { 'id': '250', 'ruta_imagen': '/img/certificados/01.png' },
    { 'id': '251', 'ruta_imagen': '/img/certificados/02.png' },
    { 'id': '250', 'ruta_imagen': '/img/certificados/03.png' },
    { 'id': '251', 'ruta_imagen': '/img/certificados/04.png' },
    { 'id': '250', 'ruta_imagen': '/img/certificados/05.png' },

]

const servicios = ref(null)
servicios.value = [
    { 'id': '101', 'label': 'Cableado Estructurado', 'descripcion': 'Diseño, implementación y mantenimiento de sistemas de cableado estructurado', 'descripcion_corta': 'Consultoría, diseño e implementación.', 'contenido': 'Cableado estructurado es la red de cables de datos que permite interconectar equipos activos de diferentes o igual tecnología permitiendo la integración de los diferentes servicios tales como: datos, telefonía, control, alarmas, etc. Realizamos todas las etapas desde la cotización y venta de insumos hasta el diseño, implementación y mantenimiento del cableado estructurado de una edificación.', 'ruta_imagen': '/img/empresa/servicios/01.jpg' },
    { 'id': '102', 'label': 'Sistemas CCTV y video vigilancia IP', 'descripcion': 'Diseño, implementación y mantenimiento de sistemas de cableado estructurado', 'descripcion_corta': 'Consultoría, diseño e implementación.', 'contenido': 'Cableado estructurado es la red de cables de datos que permite interconectar equipos activos de diferentes o igual tecnología permitiendo la integración de los diferentes servicios tales como: datos, telefonía, control, alarmas, etc. Realizamos todas las etapas desde la cotización y venta de insumos hasta el diseño, implementación y mantenimiento del cableado estructurado de una edificación.', 'ruta_imagen': '/img/empresa/servicios/02.jpg' },
    { 'id': '103', 'label': 'certificación de puntos de red', 'descripcion': 'Diseño, implementación y mantenimiento de sistemas de cableado estructurado', 'descripcion_corta': 'Consultoría, diseño e implementación.', 'contenido': 'Cableado estructurado es la red de cables de datos que permite interconectar equipos activos de diferentes o igual tecnología permitiendo la integración de los diferentes servicios tales como: datos, telefonía, control, alarmas, etc. Realizamos todas las etapas desde la cotización y venta de insumos hasta el diseño, implementación y mantenimiento del cableado estructurado de una edificación.', 'ruta_imagen': '/img/empresa/servicios/03.jpg' },
    { 'id': '104', 'label': 'sistemas de alarma contra incendio', 'descripcion': 'Diseño, implementación y mantenimiento de sistemas de cableado estructurado', 'descripcion_corta': 'Consultoría, diseño e implementación.', 'contenido': 'Cableado estructurado es la red de cables de datos que permite interconectar equipos activos de diferentes o igual tecnología permitiendo la integración de los diferentes servicios tales como: datos, telefonía, control, alarmas, etc. Realizamos todas las etapas desde la cotización y venta de insumos hasta el diseño, implementación y mantenimiento del cableado estructurado de una edificación.', 'ruta_imagen': '/img/empresa/servicios/04.jpg' },
    { 'id': '105', 'label': 'sistemas de perifoneo y sonido', 'descripcion': 'Diseño, implementación y mantenimiento de sistemas de cableado estructurado', 'descripcion_corta': 'Consultoría, diseño e implementación.', 'contenido': 'Cableado estructurado es la red de cables de datos que permite interconectar equipos activos de diferentes o igual tecnología permitiendo la integración de los diferentes servicios tales como: datos, telefonía, control, alarmas, etc. Realizamos todas las etapas desde la cotización y venta de insumos hasta el diseño, implementación y mantenimiento del cableado estructurado de una edificación.', 'ruta_imagen': '/img/empresa/servicios/05.jpg' },
    { 'id': '106', 'label': 'fusión de fibras ópticas', 'descripcion': 'Diseño, implementación y mantenimiento de sistemas de cableado estructurado', 'descripcion_corta': 'Consultoría, diseño e implementación.', 'contenido': 'Cableado estructurado es la red de cables de datos que permite interconectar equipos activos de diferentes o igual tecnología permitiendo la integración de los diferentes servicios tales como: datos, telefonía, control, alarmas, etc. Realizamos todas las etapas desde la cotización y venta de insumos hasta el diseño, implementación y mantenimiento del cableado estructurado de una edificación.', 'ruta_imagen': '/img/empresa/servicios/06.jpg' },
]

// Se usa helpers
/* const currencySymbol = (code = '') => {
    let symbol = ''
    if (code == 'PEN') {
        symbol = 'S/'
    } else if (code == 'USD') {
        symbol = '$'
    } else if (code == 'EUR') {
        symbol = '€'
    }
    return symbol
} */

</script>

<script>
export default {
    components: {},
    data() {
        return {
            cat_img: {
                rewind: true,
                autoplay: true,
                perPage: 2,
                gap: '1rem',
                type: 'loop',
                pagination: 'true',
                breakpoints: {
                    1000: {
                        perPage: 1,
                    }
                },
                perMove: 1,
                arrows: true,
            },
            // classes: {
            //     arrows: 'splide__arrows your-class-arrows',
            //     arrow: 'splide__arrow your-class-arrow',
            //     prev: 'splide__arrow--prev slider-arrow slider-prev',
            //     next: 'splide__arrow--next slider-arrow slider-next',
            // },
        }
    }
}
</script>



<template>
    <SeoMeta />
    <!-- <Head>
        <title>{{ (confGlobal.value.COMPANY_NAME_SHORT ? confGlobal.value.COMPANY_NAME_SHORT : 'Ecommerce') }}</title>

        <meta property="og:type" content="website">
        <meta property="og:url" :content="urlNow">
        <meta property="og:title" name="og:title" :content="(confGlobal.value.COMPANY_NAME_SHORT ? confGlobal.value.COMPANY_NAME_SHORT + ' - ' : '') + urlNow">
        <meta property="og:site_name" :content="urlNow">
        <meta property="og:url" :content="urlNow">
        <link rel="canonical" :href="urlNow">
        <meta name="robots" content="index, follow">
        <meta name="language" content="Spanish">
    </Head> -->

    <!-- Head con categorías -->
    <!-- Botón Ayuda -->


    <BreezeGuestLayout :categoryChild="categoryChild" :categoryParent="categoryParent" :qtyCart="qtyCart">


        <!-- START SLIDER -->
        <!-- START SLIDER -->
        <!-- START SLIDER -->

        <section class="slide-principal">
            <Splide :has-track="true" :options="{ rewind: 'true', perPage: 1, perMove: 1, type: 'loop', autoplay: true, pagination: true, arrows: true, gap: '0em', }" class="h-[400px] lg:h-[600px]" id="splide-slider" v-if="slides.length > 0">
                <!-- bg-[url('/img/slide/slide-1.png')]  -->
                <SplideSlide class="h-full" v-for="(item, index) in slides" :key="item.id">
                    <div class="bg-no-repeat bg-center bg-cover h-full relative group" :style="'background: url(/documents/ecommerce/slides/' + item.filename + ') center center no-repeat; background-size: cover;'">
                        <div class="h-full bg-black/10">
                            <div class="container mx-auto px-4 sm:px-6 lg:px-8 flex items-center h-full ">
                                <div class="w-full h-full flex items-center">
                                    <div class="sm:w-[350px] md:w-450px xl:w-[626px] w-full">
                                        <p class="lg:text-[34px] text-[20px] font-medium mb-[7px] text-gray-200">{{ item.name }}</p>
                                        <h1 class="lg:text-[45px] 2xl:text-[55px] text-[30px] font-bold lg:leading-[80px] leading-[40px] mb-8 lg:mb-[44px] text-white">
                                            {{ item.description }}
                                        </h1>
                                        <div v-if="item.product_id > 0">
                                            <Link :href="route('eco-product-show', { id: item.product_id })">
                                                <div class="px-3 lg:px-5 py-2 lg:py-3 inline-flex justify-center items-center group rounded bg-color text-white relative transition-all duration-300 ease-in-out overflow-hidden cursor-pointer">
                                                    <div class="flex space-x-1 items-center transition-all duration-300 ease-in-out relative z-10">
                                                        <span class="text-xs lg:text-sm font-600 leading-7 mr-2">Compra ahora

                                                        </span>

                                                        <BaseIcon :path="mdiChevronRight" :size="24" w="w-6" h="h-6" class="m-0"></BaseIcon>

                                                    </div>
                                                    <div class="w-full h-full bg-black absolute top-0 left-0 right-0 bottom-0 transform scale-x-0 group-hover:scale-x-100 origin-[center_left] group-hover:origin-[center_right]" style="transition: transform 0.25s ease-in-out;"></div>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </SplideSlide>
            </Splide>

        </section>
        <!-- END SLIDER -->
        <!-- END SLIDER -->
        <!-- END SLIDER -->


        <!-- START BENEFICIOS -->
        <!-- START BENEFICIOS -->
        <!-- START BENEFICIOS -->
        <section class="py-8">
            <div class="mx-auto px-4 sm:px-6 lg:px-8">
                <div class="w-full bg-gray-100 rounded-md flex flex-col space-y-10 lg:space-y-0 lg:flex-row lg:justify-between lg:items-center lg:h-[110px] px-10 lg:py-0 py-10 shadow-xl shadow-gray-400/10">
                    <div v-if="!helpers.isEmpty(confGlobal.value.ENVIO_GRATUITO_DETAIL)">
                        <div class="flex space-x-5 items-center">
                            <div>
                                <BaseIcon :path="mdiTruckFastOutline" :size="45" class="icon-color" w="w-14" h="h-14"></BaseIcon>
                            </div>
                            <div>
                                <p class="text-black text-[15px] font-bold tracking-wide mb-1">
                                    Envío gratis</p>
                                <p class="text-sm ">{{ confGlobal.value.ENVIO_GRATUITO_DETAIL }}</p>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="flex space-x-5 items-center">
                            <div>
                                <BaseIcon :path="mdiReload" :size="45" class="icon-color" w="w-14" h="h-14"></BaseIcon>
                            </div>
                            <div>
                                <p class="text-black text-[15px] font-bold tracking-wide mb-1">Devolución o Reemplazo</p>
                                <p class="text-sm ">Revise nuestra política de garantía</p>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="flex space-x-5 items-center">
                            <div>
                                <BaseIcon :path="mdiShieldLockOutline" :size="45" class="icon-color" w="w-14" h="h-14"></BaseIcon>
                            </div>
                            <div>
                                <p class="text-black text-[15px] font-bold tracking-wide mb-1">Pago Seguro</p>
                                <p class="text-sm ">Pago seguro con asesor</p>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="flex space-x-5 items-center">
                            <div>
                                <BaseIcon :path="mdiTrophyOutline" :size="45" class="icon-color" w="w-14" h="h-14"></BaseIcon>
                            </div>
                            <div>
                                <p class="text-black text-[15px] font-bold tracking-wide mb-1">Directo de marca</p>
                                <p class="text-sm ">Producto original garantizado</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- END BENEFICIOS -->
        <!-- END BENEFICIOS -->
        <!-- END BENEFICIOS -->


        <!-- START CATEGORIA POR IMAGEN -->
        <!-- START CATEGORIA POR IMAGEN -->
        <!-- START CATEGORIA POR IMAGEN -->
        <section class="py-8">
            <div class="mx-auto px-4 sm:px-6 lg:px-8">
                <div class=" flex justify-between items-center mb-5">
                    <div>
                        <h1 class="sm:text-3xl text-xl font-600 leading-none">Categorias</h1>
                    </div>
                    <!-- <div>
                        <a href="#">
                            <div class="flex space-x-2 items-center">
                                <p class="text-base font-600 hidden lg:block a-color">Ver Más</p>
                                <span>
                                    <BaseIcon :path="mdiArrowRight" :size="32" class="icon-color" w="w-12" h="h-12"></BaseIcon>
                                </span>
                            </div>
                        </a>
                    </div> -->
                </div>
                <div class="relative slide-secundario" v-if="categories.length > 0">
                    <Splide :has-track="true" :options="{ rewind: 'true', perMove: 1, type: 'loop', autoplay: true, pagination: boolean = false, arrows: true, gap: '1em', mediaQuery: 'min', breakpoints: { 1890: { perPage: 6 }, 1536: { perPage: 5 }, 1280: { perPage: 4 }, 640: { perPage: 3 }, 0: { perPage: 2, } } }" class="rounded-md h-[180px] lg:h-[200px]" id="splide-cat">
                        <SplideSlide class="rounded-md h-full " v-for="(item, index) in categories" :key="item.id">
                            <!-- <div class="bg-[url('/img/categorias/01.jpg')] bg-no-repeat bg-center bg-cover rounded-md h-full relative group"> -->
                            <div class="bg-no-repeat bg-center bg-cover rounded-md h-full relative group" :style="'background: url(' + (item.files[0] ? '/documents/' + item.files[0].filepath + '/' + item.files[0].filename : '') + ') center center no-repeat; background-size: cover;'">
                                <div class="absolute w-full h-10 px-[30px] left-0 -top-14 group-hover:top-16 lg:group-hover:top-20 transition-all duration-300 ease-in-out ">
                                    <div class="flex justify-center">
                                        <button type="button" class="btn btn-color btn-ico flex justify-center">
                                            <Link :href="route('eco-product-category', { id: item.id, parent: item.id })">
                                                <div class="flex items-center lg:space-x-3">
                                                    <BaseIcon :path="mdiShoppingOutline" :size="24" class="text-white hidden lg:inline-block" w="w-6" h="h-6"></BaseIcon>
                                                    <span>Ver más</span>
                                                </div>
                                            </Link>
                                        </button>
                                    </div>
                                </div>
                                <div class="rounded-md h-full">
                                    <div class="text-white p-6 bottom-0 flex items-end h-full bg-black/30 rounded-md">
                                        <p class=" text-sm lg:text-lg font-semibold">{{ item.label }}</p>
                                    </div>
                                </div>
                            </div>
                        </SplideSlide>
                    </Splide>
                </div>
                <div class="relative slide-secundario" v-if="confGlobal.value.ECOMMERCE_ENABLE_WELCOME_EXAMPLE == 1">
                    <Splide :has-track="true" :options="{ rewind: 'true', perMove: 1, type: 'loop', autoplay: true, pagination: boolean = false, arrows: true, gap: '1em', mediaQuery: 'min', breakpoints: { 1890: { perPage: 6 }, 1536: { perPage: 5 }, 1280: { perPage: 4 }, 640: { perPage: 3 }, 0: { perPage: 2, } } }" class="rounded-md h-[180px] lg:h-[200px]" id="splide-cat">
                        <SplideSlide class="rounded-md h-full " v-for="(item, index) in categorias" :key="item.id">

                            <div class="bg-no-repeat bg-center bg-cover rounded-md h-full relative group" :style="'background: url(' + item.ruta_imagen + ') center center no-repeat; background-size: cover;'">
                                <div class="absolute w-full h-10 px-[30px] left-0 -top-14 group-hover:top-16 lg:group-hover:top-20 transition-all duration-300 ease-in-out ">
                                    <div class="flex justify-center">
                                        <button type="button" class="btn btn-color btn-ico flex justify-center">
                                            <Link :href="route('eco-product-category', { id: 1 })">
                                                <div class="flex items-center lg:space-x-3">
                                                    <BaseIcon :path="mdiShoppingOutline" :size="24" class="text-white hidden lg:inline-block" w="w-6" h="h-6"></BaseIcon>
                                                    <span>Ver más</span>
                                                </div>
                                            </Link>
                                        </button>
                                    </div>

                                </div>
                                <div class="rounded-md h-full">

                                    <div class="text-white p-6 bottom-0 flex items-end h-full bg-black/30 rounded-md">
                                        <p class=" text-sm lg:text-lg font-semibold">{{ item.label }}</p>
                                    </div>
                                </div>
                            </div>
                        </SplideSlide>
                    </Splide>
                </div>
            </div>

        </section>
        <!-- END CATEGORIA POR IMAGEN -->
        <!-- END CATEGORIA POR IMAGEN -->
        <!-- END CATEGORIA POR IMAGEN -->

        <!-- START NUEVOS PRODUCTOS -->
        <!-- START NUEVOS PRODUCTOS -->
        <!-- START NUEVOS PRODUCTOS -->
        <section class="py-8">
            <div class="mx-auto px-4 sm:px-6 lg:px-8">
                <div class="flex justify-between items-center mb-5">
                    <div>
                        <h1 class="sm:text-3xl text-xl font-600 leading-none">Nuevos Productos</h1>
                    </div>
                    <div>
                        <Link :href="route('eco-product-category', { id: 0, label: '' })">
                            <div class="flex space-x-2 items-center">
                                <p class="text-base font-600 hidden lg:block a-color">Ver Más</p>
                                <span>
                                    <BaseIcon :path="mdiArrowRight" :size="32" class="icon-color" w="w-12" h="h-12"></BaseIcon>
                                </span>
                            </div>
                        </Link>
                    </div>
                </div>
                <div v-if="lastproducts.length > 0">
                    <div class="w-full">
                        <div class="grid xl:grid-cols-5 2xl:grid-cols-5 lg:grid-cols-3 sm:grid-cols-2 grid-cols-1 xl:gap-[30px] gap-5">
                            <div v-for="(item, index) in lastproducts" :key="item.id" class="shadow-xl shadow-gray-400/10 rounded-lg border">
                                <div class="w-full h-full bg-white relative group overflow-hidden rounded-lg">
                                    <Link :href="route('eco-product-show', { id: item.id })">
                                        <!-- <div class="w-full h-[300px]" :style="'background: url(' + (item.files[0] ? '/documents/' + item.files[0].filepath + '/' + item.files[0].filename : '') + ') center center no-repeat; background-size: cover;'">
                                        </div> -->
                                        <div class="relative h-[300px]">
                                            <img :src="(item.files[0] ? '/documents/' + item.files[0].filepath + '/' + item.files[0].filename : '')" alt="" class="w-full h-full object-contain">
                                            <div class="absolute left-[14px] bottom-[28px]">
                                                <div v-if="item.stockable_product == 1 && item.stock > 0" class="flex">
                                                    <div class="text-xs font-700 leading-none py-2 px-2 uppercase text-white rounded-full bg-lime-500 flex items-center">
                                                        <BaseIcon :path="mdiMoped" :size="18" w="w-5" h="h-5"></BaseIcon><span>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Link>
                                    <div class="absolute left-[14px] top-[28px]">
                                        <div class="flex flex-col gap-2">
                                            <div v-if="item.list_price_ttc > item.price_ttc" class="flex">
                                                <div class="text-xs font-700 leading-none py-[5px] px-3 uppercase text-white rounded-full bg-rose-600 flex items-center">
                                                    <BaseIcon :path="mdiPercent" :size="18" class="mr-2" w="w-5" h="h-5"></BaseIcon><span>
                                                        {{ helpers.unensRound((item.list_price_ttc - item.price_ttc) * 100 / item.list_price_ttc) }} Dto.
                                                    </span>
                                                </div>
                                            </div>

                                            <div v-if="item.stockable_product == 2" class="flex">
                                                <div class="text-xs font-700 leading-none py-[5px] px-3 uppercase text-white rounded-full bg-blue-600 flex items-center">
                                                    <BaseIcon :path="mdiArchivePlus" :size="18" class="mr-2" w="w-5" h="h-5"></BaseIcon><span> A pedido
                                                    </span>
                                                </div>
                                            </div>
                                            <div v-if="item.stockable_product == 3" class="flex">
                                                <div class="text-xs font-700 leading-none py-[5px] px-3 uppercase text-white rounded-full bg-violet-500 flex items-center">
                                                    <BaseIcon :path="mdiAirplane" :size="18" class="mr-2" w="w-" h="h-5"></BaseIcon><span>En transito
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    <div class="px-[30px] pb-[30px] relative">
                                        <div class="absolute w-full h-10 px-[30px] left-0 top-40 group-hover:top-[100px] transition-all duration-300 ease-in-out xl:block hidden">
                                            <button type="button" class="btn btn-color btn-ico w-full flex justify-center" @click="addCart(item.id, 1, item.ref, item.label, item.price_ttc)">
                                                <div class="flex items-center space-x-3">
                                                    <!-- <span v-if="(item.list_price_ttc > 0)" class="text-base line-through text-gray-600 mt-2 mr-2">
                                                        {{ helpers.currencySymbol(confGlobal.value.COMPANY_MULTICURRENCY_CODE) }} {{ item.list_price_ttc }}
                                                     </span> -->
                                                    <BaseIcon :path="mdiShoppingOutline" :size="24" class="text-white" w="w-4" h="h-4"></BaseIcon>
                                                    <span>Agregar al carrito</span>
                                                </div>
                                            </button>
                                        </div>
                                        <div class="flex items-center justify-between h-[30px]">
                                            <!-- <div>
                                                <div v-if="item.rating > 0" class="reviews flex space-x-[1px]">
                                                    <span v-for="i in item.rating">
                                                        <BaseIcon :path="mdiStar" :size="20" class="text-yellow-400" w="w-6" h="h-6"></BaseIcon>
                                                    </span>
                                                </div>
                                            </div> -->
                                            <div>
                                                <div class="reviews flex space-x-[1px]">
                                                    <span>
                                                        {{ (item.brand ? ' ' + item.brand.label : '') }}
                                                    </span>
                                                </div>
                                            </div>
                                            <div>
                                                <template v-if="Object.keys(confGlobal.value).length > 0">
                                                    <p v-if="item.stock <= 0 && confGlobal.value.PRODUCT_STOCK_ZERO_LABEL" class="text-gray-700 text-sm">
                                                        <span class="text-gray-800 font-semibold">{{ confGlobal.value.PRODUCT_STOCK_ZERO_LABEL }}</span>
                                                    </p>
                                                    <p v-else class="text-gray-700 text-sm">Stock <span class="text-gray-800 font-semibold">{{ (stocklabel ? (item.stock > parseInt(stocklabel) ? 'Disponible' : 'Limitado') : (item.stock > parseInt(confGlobal.value.PRODUCT_STOCK_LABEL || 30) ? '+ ' + (confGlobal.value.PRODUCT_STOCK_LABEL || '30') : item.stock)) }}</span></p>
                                                </template>
                                            </div>
                                        </div>
                                        <div class="h-[100px] grid content-between">
                                            <div class="mb-2 limit-line line-2">
                                                <Link :href="route('eco-product-show', { id: item.id })">
                                                    <p class="!capitalize text-[15px] font-semibold leading-[24px]">{{ item.label }}</p>
                                                </Link>
                                            </div>
                                            <p>
                                                <span class="offer-price text-qred font-semibold text-base ml-2 text-gray-800">{{ helpers.currencySymbol(confGlobal.value.COMPANY_MULTICURRENCY_CODE) }} {{ item.price_ttc }}</span>
                                                <span v-if="item.list_price_ttc > 0" class="main-price text-gray-500 line-through font-600 text-sm pl-2">{{ helpers.currencySymbol(confGlobal.value.COMPANY_MULTICURRENCY_CODE) }} {{ item.list_price_ttc }}</span>
                                            </p>
                                        </div>
                                        <div class="xl:hidden block mt-3">
                                            <button type="button" class="btn btn-color btn-ico w-full flex justify-center" @click="addCart(item.id, 1, item.ref, item.label, item.price_ttc)">
                                                <div class="flex items-center space-x-3">
                                                    <BaseIcon :path="mdiShoppingOutline" :size="24" class="text-white" w="w-4" h="h-4"></BaseIcon>
                                                    <span>Agregar al carrito</span>
                                                </div>
                                            </button>
                                        </div>
                                    </div>
                                    <!-- <div class="quick-access-btns flex flex-col space-y-2 absolute group-hover:right-4 -right-10 top-20  transition-all duration-300 ease-in-out">
                                        <a href="#">
                                            <span class="w-10 h-10 flex justify-center items-center bg-gray-200/50 rounded">
                                                <BaseIcon :path="mdiArrowExpandAll" :size="24" class="icon-color-black" w="w-6" h="h-6"></BaseIcon>
                                            </span>
                                        </a><a href="#">
                                            <span class="w-10 h-10 flex justify-center items-center bg-gray-200/50 rounded">
                                                <BaseIcon :path="mdiHeartOutline" :size="24" class="icon-color-black" w="w-6" h="h-6"></BaseIcon>
                                            </span>
                                        </a>
                                        <a href="#">
                                            <span class="w-10 h-10 flex justify-center items-center bg-gray-200/50 rounded">
                                                <BaseIcon :path="mdiRepeat" :size="24" class="icon-color-black" w="w-6" h="h-6"></BaseIcon>
                                            </span>
                                        </a>
                                    </div> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="confGlobal.value.ECOMMERCE_ENABLE_WELCOME_EXAMPLE == 1">
                    <div class="w-full">
                        <div class="grid xl:grid-cols-4 lg:grid-cols-3 sm:grid-cols-2 grid-cols-1 xl:gap-[30px] gap-5">
                            <div v-for="(item, index) in productosNuevos" :key="item.id" class="shadow-xl shadow-gray-400/10 rounded-lg">
                                <div class="w-full h-full bg-white relative group overflow-hidden rounded-lg">
                                    <Link :href="route('eco-product-show', { id: item.id })">
                                        <div class="w-full h-[300px]" :style="'background: url(' + item.ruta_imagen + ') center center no-repeat; background-size: cover;'">
                                        </div>
                                    </Link>
                                    <div class="absolute right-[14px] top-[17px]">
                                        <div class="flex flex-col gap-2">
                                            <!-- <div v-if="item.popular" class="flex items-center justify-center rounded-full bg-[#19CC40] py-1 px-3">
                                                <BaseIcon :path="mdiStar" :size="22" class="pr-1 text-white" w="w-6" h="h-6"></BaseIcon><span class="text-xs font-700 leading-none uppercase text-white text-center">En Stock</span>
                                            </div> -->
                                            <div v-if="item.stock_type == 3" class="flex items-center justify-center rounded-full bg-violet-600 py-1 px-3">
                                                <BaseIcon :path="mdiAirplane" :size="22" class="pr-1 text-white" w="w-6" h="h-6"></BaseIcon><span class="text-xs font-700 leading-none uppercase text-white text-center">En transito</span>
                                            </div>
                                            <div v-if="item.stock_type == 2" class="flex items-center justify-center rounded-full bg-blue-600 py-1 px-3">
                                                <BaseIcon :path="mdiArchivePlus" :size="22" class="pr-1 text-white" w="w-6" h="h-6"></BaseIcon><span class="text-xs font-700 leading-none uppercase text-white text-center">A pedido</span>
                                            </div>
                                        </div>

                                    </div>
                                    <div class="px-[30px] pb-[30px] relative">
                                        <div class="absolute w-full h-10 px-[30px] left-0 top-40 group-hover:top-[85px] transition-all duration-300 ease-in-out">
                                            <button type="button" class="btn btn-color btn-ico w-full flex justify-center">
                                                <div class="flex items-center space-x-3">
                                                    <BaseIcon :path="mdiShoppingOutline" :size="24" class="text-white" w="w-4" h="h-4"></BaseIcon>
                                                    <span>Agregar al carrito</span>
                                                </div>
                                            </button>
                                        </div>
                                        <div class="flex items-center justify-between mb-3">
                                            <div class="h-[30px]">
                                                <div v-if="item.rating > 0" class="reviews flex space-x-[1px]">
                                                    <span v-for="i in item.rating">
                                                        <BaseIcon :path="mdiStar" :size="20" class="text-yellow-400" w="w-6" h="h-6"></BaseIcon>
                                                    </span>
                                                </div>
                                            </div>

                                            <div>
                                                <p class="text-gray-700 text-sm">Stock <span class="text-gray-800 font-semibold">{{ (stocklabel ? (item.stock > 2 ? 'Disponible' : 'Limitado') : item.stock) }}</span></p>
                                            </div>
                                        </div>

                                        <div class="h-[83px] grid content-between">
                                            <a href="#">
                                                <p class="mb-2 text-[15px] font-semibold leading-[24px] line-clamp-2 a-color">{{ item.label }}</p>
                                            </a>
                                            <p><span class="main-price text-gray-500 line-through font-600 text-sm">{{ item.moneda_simb }} {{ item.precio_lista }}</span><span class="offer-price text-qred font-semibold text-base ml-2 text-gray-800">{{ item.moneda_simb }} {{ item.precio }}</span></p>
                                        </div>

                                    </div>
                                    <!-- <div class="quick-access-btns flex flex-col space-y-2 absolute group-hover:right-4 -right-10 top-20  transition-all duration-300 ease-in-out">
                                        <a href="#">
                                            <span class="w-10 h-10 flex justify-center items-center bg-gray-200/50 rounded">
                                                <BaseIcon :path="mdiArrowExpandAll" :size="24" class="icon-color-black" w="w-6" h="h-6"></BaseIcon>
                                            </span>
                                        </a><a href="#">
                                            <span class="w-10 h-10 flex justify-center items-center bg-gray-200/50 rounded">
                                                <BaseIcon :path="mdiHeartOutline" :size="24" class="icon-color-black" w="w-6" h="h-6"></BaseIcon>
                                            </span>
                                        </a>
                                        <a href="#">
                                            <span class="w-10 h-10 flex justify-center items-center bg-gray-200/50 rounded">
                                                <BaseIcon :path="mdiRepeat" :size="24" class="icon-color-black" w="w-6" h="h-6"></BaseIcon>
                                            </span>
                                        </a>
                                    </div> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- END NUEVOS PRODUCTOS -->
        <!-- END NUEVOS PRODUCTOS -->
        <!-- END NUEVOS PRODUCTOS -->


        <!-- START PROMOCIONES -->
        <!-- START PROMOCIONES -->
        <!-- START PROMOCIONES -->
        <section class="py-8" v-if="confGlobal.value.ECOMMERCE_ENABLE_PROMOCIONES == 1 && promos.length > 0">
            <div class="mx-auto px-4 sm:px-6 lg:px-8">
                <div class="flex justify-between items-center mb-5">
                    <div>
                        <h1 class="sm:text-3xl text-xl font-600 leading-none">Ultimas Promociones</h1>
                    </div>
                    <div>
                        <a href="#">
                            <div class="flex space-x-2 items-center">
                                <p class="text-base font-600 hidden lg:block a-color">Ver Más</p>
                                <span>
                                    <BaseIcon :path="mdiArrowRight" :size="32" class="icon-color" w="w-12" h="h-12"></BaseIcon>
                                </span>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="grid grid-cols-1 lg:grid-cols-2 gap-4">
                    <div class="col-span-1 bg-white shadow-xl shadow-gray-400/10 rounded-lg" v-for="(item, index) in promos" :key="index">
                        <div class="rounded-md overflow-hidden block">
                            <Link :href="route('eco-product-show', { id: item.product_id })">
                                <img :src="'/documents/ecommerce/promos/' + item.filename" alt="" class="hover:scale-110 ease-in duration-500 w-full">
                            </Link>
                        </div>
                    </div>

                </div>
            </div>
        </section>
        <!-- END PROMOCIONES -->
        <!-- END PROMOCIONES -->
        <!-- END PROMOCIONES -->


        <!-- START PRODUCTOS DESTACADOS -->
        <!-- START PRODUCTOS DESTACADOS -->
        <!-- START PRODUCTOS DESTACADOS -->

        <!-- <section class="py-8">
            <div class="mx-auto px-4 sm:px-6 lg:px-8">

                <div class="flex justify-between items-center mb-5">
                    <div>
                        <h1 class="sm:text-3xl text-xl font-600 leading-none">Productos Destacados</h1>
                    </div>

                    <div>
                        <a href="#">
                            <div class="flex space-x-2 items-center">
                                <p class="text-base font-600 hidden lg:block a-color">Ver Más</p>
                                <span>
                                    <BaseIcon :path="mdiArrowRight" :size="32" class="icon-color" w="w-12" h="h-12"></BaseIcon>
                                </span>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="grid grid-cols-1 sm:grid-cols-1 xl:grid-cols-11 2xl:grid-cols-12 gap-4 " v-if="productosDestacados.length > 0">
                    <div class="col-span-1 xl:col-span-3 2xl:col-span-3">
                        <div class="p-5 border-2 border-color rounded-3xl shadow-xl shadow-gray-400/10 w-full grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-1">
                            <div class="hidden sm:block xl:hidden">
                                <div class="sm:max-w-full h-[300px] lg:h-[400px] relative ">

                                    <div class="absolute left-[14px] bottom-[25%]">
                                        <span class="text-xs font-700 leading-none py-[6px] px-3 uppercase text-white rounded-full bg-rose-600">25% de Dscto.</span>
                                    </div>
                                    <img src="/img/productos_destacados/01.png" class="h-full w-full !object-contain">
                                </div>
                            </div>
                            <div class="flex items-center justify-center w-full sm:w-auto xl:w-full">
                                <div class="w-full sm:w-auto xl:w-full">
                                    <div class="flex justify-between items-center">
                                        <div>
                                            <p class="mb-3 font-medium text-lg !text-gray-800">El <span class="font-bold">más</span> solicitado</p>
                                            <p class="text-xs text-gray-500">Smartphones</p>
                                        </div>
                                        <div class="rounded-full  bg-gradient-to-bl from-yellow-300 to-yellow-500 w-14 h-14 flex items-center justify-center">
                                            <BaseIcon :path="mdiTrophyOutline" :size="40" class=" text-white" w="w-12" h="h-12"></BaseIcon>
                                        </div>

                                    </div>
                                    <div>
                                        <a href="#" class="text-lg font-bold text-color">Iphone 15 Pro Max</a>
                                    </div>
                                    <div class="sm:hidden xl:block flex flex-row justify-center w-full">
                                       
                                        <div class="w-full max-w-[300px] sm:max-w-full h-[300px] lg:h-[400px] relative ">
                                            <div class="absolute left-[14px] bottom-[25%]">
                                                <span class="text-xs font-700 leading-none py-[6px] px-3 uppercase text-white rounded-full bg-rose-600">25% de Dscto.</span>
                                            </div>
                                            <img src="/img/productos_destacados/01.png" class="h-full w-full !object-contain">
                                        </div>
                                    </div>
                                    <div class="flex justify-center mb-4 w-full">
                                        <div>
                                            <div class="text-gray-700">
                                                <p class="text-left text-sm lg:text-base ">Por promoción llevatelo a solo:</p>
                                            </div>
                                            <div class="mb-4 flex flex-col justify-center w-full">
                                                <p class="text-xl font-semibold text-gray-800 text-center">S/ 4500.00</p>
                                                <span class="text-sm line-through text-gray-500 text-center">S/ 5200.00</span>
                                            </div>
                                            <div class="flex justify-center w-full">
                                                <button type="button" class="btn btn-color btn-ico flex justify-center">
                                                    <div class="flex items-center space-x-3">
                                                        <BaseIcon :path="mdiShoppingOutline" :size="24" class="text-white" w="w-4" h="h-4"></BaseIcon>
                                                        <span>Agregar al carrito</span>
                                                    </div>
                                                </button>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="sm:grid-cols-1 xl:col-span-8 2xl:col-span-9 h-full">
                        <div class="w-full grid md:grid-cols-2 grid-cols-1 gap-4 h-full">
                            <div class="h-1/3 col-span-1" v-for="(item, index) in productosDestacados" :key="item.id">
                                <div class="w-full h-[210px] bg-white group relative overflow-hidden rounded-lg shadow-xl shadow-gray-400/10">
                                    <div class="flex space-x-5 items-center w-full h-full lg:p-4">
                                        <div class="lg:w-1/2 w-1/3 h-full">
                                            <img :src="item.ruta_imagen" alt="" class="w-full h-full object-contain">
                                        </div>
                                        <div class="flex-1 flex flex-col justify-center h-full lg:p-0 pl-0 pr-4">
                                            <div>
                                                <div class="flex items-center space-x-1 mb-2">
                                                    <BaseIcon :path="mdiArchivePlus" :size="22" class="pr-1 text-blue-600" w="w-6" h="h-6"></BaseIcon><span class="text-xs font-semibold leading-none uppercase text-gray-700 text-center">A pedido</span>
                                                </div>
                                                <div class="mb-2 limit-line line-2">
                                                    <Link :href="route('eco-product-show', { id: item.id })">
                                                    <p class="mb-2 sm:text-sm text-xs !capitalize text-[15px] font-semibold leading-[24px] a-color">{{ item.label }}</p>
                                                    </Link>
                                                </div>
                                                <p class="mb-4">
                                                    <span class="line-through font-600 text-gray-500 text-sm">{{ item.moneda_simb }} {{ item.precio_lista }}</span>
                                                    <span class="font-semibold text-gray-800 text-base ml-2">{{ item.moneda_simb }} {{ item.precio }}</span>
                                                </p>
                                                <button type="button" class="btn btn-color btn-ico flex justify-center">
                                                    <div class="flex items-center space-x-3">
                                                        <BaseIcon :path="mdiShoppingOutline" :size="24" class="text-white" w="w-4" h="h-4"></BaseIcon>
                                                        <span>Agregar al carrito</span>
                                                    </div>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section> -->

        <!-- END PRODUCTOS DESTACADOS -->
        <!-- END PRODUCTOS DESTACADOS -->
        <!-- END PRODUCTOS DESTACADOS -->

        <!-- START CERTIFICADOS -->
        <!-- START CERTIFICADOS -->
        <!-- START CERTIFICADOS -->
        <section v-if="certificates.length > 0" class="py-12">
            <div class="mx-auto px-4 sm:px-6 lg:px-8">
                <div class="grid grid-cols-1 gap-4">
                    <div class="col-span-1 mb-10">
                        <h1 class="sm:text-3xl text-xl font-600 leading-none text-center">Certificados que nos respaldan</h1>
                        <!-- <p class="mb-4 text-lg text-center"> En un entorno digital, la confianza y validez es indispensable.
                        </p> -->
                    </div>
                    <div class="flex flex-row justify-center">
                        <div class="basis-full lg:basis-3/4 2xl:basis-2/3">
                            <div class="flex flex-wrap justify-center gap-4 md:gap-8 lg:gap-10">
                                <div class="flex justify-center items-center max-w-[140px] lg:max-w-[200px] 2xl:max-w-[250px] m-4 lg:m-6" v-for="(item, index) in certificates" :key="item.id">
                                    <img :src="'/documents/ecommerce/certs/' + item.filename" class="w-full h-full max-h-16 lg:max-h-20 object-contain">
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </section>

        <!-- END CERTIFICADOS -->
        <!-- END CERTIFICADOS -->
        <!-- END CERTIFICADOS -->

        <!-- START SERVICIOS -->
        <!-- START SERVICIOS -->
        <!-- START SERVICIOS -->
        <section class="py-12">
            <div class="mx-auto px-4 sm:px-6 lg:px-8">
                <div class="flex justify-between items-center mb-5">
                    <div>
                        <h1 class="sm:text-3xl text-xl font-600 leading-none">Servicios que ofrecemos</h1>
                    </div>
                    <div>
                        <Link :href="route('eco-services')">
                            <div class="flex space-x-2 items-center">
                                <p class="text-base font-600 hidden lg:block a-color">Ver Más</p>
                                <span>
                                    <BaseIcon :path="mdiArrowRight" :size="32" class="icon-color" w="w-12" h="h-12"></BaseIcon>
                                </span>
                            </div>
                        </Link>
                    </div>
                </div>
                <div class="grid grid-cols-1 lg:grid-cols-2 gap-8">
                    <div>
                        <div class="mb-5">
                            <div v-html="confGlobal.value.SERVICES_CONTENT_INTRODUCTION_PAGE" class="mb-8"></div>
                        </div>
                        <div class="mb-5 grid grid-cols-1 xl:grid-cols-2 gap-2" v-if="lastservices.length > 0">
                            <div class="lg:p-2 flex items-center gap-3" v-for="(item, index) in lastservices" :key="item.id">
                                <BaseIcon :path="mdiCableData" :size="26" w="w-8" h="h-8" class=" text-color"></BaseIcon>
                                {{ item.label }}
                            </div>
                        </div>
                        <div>
                            <Link :href="route('eco-services')" class="btn btn-color btn-ico px-10">
                                <BaseIcon :path="mdiArrowRight" :size="20" class="mr-2" /> Ver más información
                            </Link>
                        </div>
                    </div>
                    <div class="h-full">
                        <div class="h-full bg-[url('/documents/ecommerce/docs/img_services.jpg')]  bg-no-repeat bg-center bg-cover min-h-[300px] lg:min-h-[450px]"></div>
                        <!-- <img src="/img/services/01.jpg" alt="" class="w-full  lg:h-full object-contain"> -->
                    </div>
                </div>
            </div>
        </section>
        <!-- END SERVICIOS -->
        <!-- END SERVICIOS -->
        <!-- END SERVICIOS -->

        <!--START MARCAS -->
        <!--START MARCAS -->
        <!--START MARCAS -->
        <section class="py-8">
            <div class="mx-auto px-4 sm:px-6 lg:px-8">
                <div class="flex justify-between items-center mb-5">
                    <div>
                        <h1 class="sm:text-3xl text-xl font-600 leading-none">Marcas que ofrecemos</h1>
                    </div>
                    <div>
                        <Link :href="route('eco-brands')">
                            <div class="flex space-x-2 items-center">
                                <p class="text-base font-600 hidden lg:block a-color">Ver Más</p>
                                <span>
                                    <BaseIcon :path="mdiArrowRight" :size="32" class="icon-color" w="w-12" h="h-12"></BaseIcon>
                                </span>
                            </div>
                        </Link>
                    </div>
                </div>
                <div class="relative slider-marcas slider-marcas-color" v-if="lastbrands.length > 0">
                    <hr class="my-4">
                    <Splide :has-track="true" :options="{ rewind: 'true', perMove: 1, type: 'loop', autoplay: true, pagination: false, arrows: true, gap: '1em', mediaQuery: 'min', breakpoints: { 1820: { perPage: 7 }, 1536: { perPage: 6 }, 1023: { perPage: 4 }, 640: { perPage: 2 }, 0: { perPage: 1 } } }" class="rounded-md" id="">
                        <SplideSlide class="rounded-md w-full h-full " v-for="(item, index) in lastbrands" :key="item.id">
                            <div class="w-full h-[110px] lg:h-[150px] marca" :title="item.label">
                                <Link :href="route('eco-product-category', { id: 0, label: '', originbrand: item.id })" class="">
                                    <img :src="(item.files[0] ? '/documents/' + item.files[0].filepath + '/' + item.files[0].filename : '')" class="hover:grayscale h-14 xl:h-20 !object-contain transition-all ease-in-out duration-500">
                                </Link>
                            </div>
                        </SplideSlide>
                    </Splide>
                    <hr class="my-4">
                </div>
            </div>
        </section>

        <!-- END MARCAS -->
        <!-- END MARCAS -->
        <!-- END MARCAS -->

        <div class="py-6">
        </div>
    </BreezeGuestLayout>
</template>

<style scoped>
/* #ttcmssubbanner .subbanner a::before {
    background: rgba(255, 255, 255, .7) none repeat scroll 0 0;
    bottom: 20px;
    content: "";
    left: 20px;
    opacity: 1;
    -moz-opacity: 1;
    -khtml-opacity: 1;
    -webkit-opacity: 1;
    position: absolute;
    right: 20px;
    top: 20px;
    transform: scale(0);
    -webkit-transform: scale(0);
    -moz-transform: scale(0);
    -o-transform: scale(0);
    -ms-transform: scale(0);

} */
</style>
